import { useTranslation } from "@/framework-originated/i18n";
import { persistLang, type SupportedLang } from "@/framework-originated/i18n/config";

// 语言切换器(doc/049 D5/D6):切换即持久化到 localStorage["BizConsole-lang"],
// 两端 shell 共用;默认 zhCN。
export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { i18n } = useTranslation();
  const current = (i18n.language as SupportedLang) === "en" ? "en" : "zhCN";
  return (
    <select
      className={`h-8 rounded-md border bg-background px-2 text-xs ${className}`}
      value={current}
      onChange={(e) => {
        const lang = e.target.value as SupportedLang;
        persistLang(lang);
        i18n.changeLanguage(lang);
      }}
      aria-label="Language"
    >
      <option value="zhCN">中文</option>
      <option value="en">EN</option>
    </select>
  );
}